"use client";

import React from "react"; 
import AnimatedCount from "./CountUp/AnimatedCount";

export const dynamic = "force-dynamic";

const QuickCounterFacts = () => {
    const counterData = [
        {
            id: 1,
            preNumber: 7,
            title: "Years",
            titleColor: "text-[#FF03B8]",
            description: "Total Experience",
            suffix: "+",
        },
        {
            id: 2,
            preNumber: 170,
            title: "",
            titleColor: "text-[#0034ED]",
            description: "Project Completed",
            suffix: "+",
        },
        {
            id: 3,
            preNumber: 50,
            title: "",
            titleColor: "text-[#618708]",
            description: "Project In Progress",
            suffix: "+",
        },
        {
            id: 4,
            preNumber: 150,
            title: "",
            titleColor: "text-[#E28B41]",
            description: "Tech Experts On Board",
            suffix: "+",
        },
        {
            id: 5,
            preNumber: 7,
            title: "",
            titleColor: "text-[#0EAD87]",
            description: "Clients of 8+ years",
            suffix: "+",
        },
        {
            id: 6,
            preNumber: 90,
            title: "",
            titleColor: "text-[#AD0E0E]",
            description: "Client Retention",
            suffix: "%+",
        },
        {
            id: 7,
            preNumber: 4.8,
            title: "",
            titleColor: "text-[#AD8A0E]",
            description: "Client Ratings",
            suffix: "/5",
        },
        {
            id: 8,
            preNumber: 12,
            title: "Countries",
            titleColor: "text-[#349EFF]",
            description: "Global Presence",
            suffix: "+",
        },
    ];

    const counterList = counterData?.map((item, ind) => {
        return (
            <div
                className="max-w-xs py-4 mx-auto flex flex-col justify-center items-center"
                key={item?.id || ind}
            >
                <h2
                    id="counter"
                    className={`font-bold font-manrope xl:text-5xl text-2xl flex flex-row gap-5 break-words ${item?.titleColor}`}
                >

                    <AnimatedCount end={item?.preNumber} suffix={item?.suffix} />

                    <span>{item?.title}</span>
                </h2>
                <h3 className="px-8 mt-5 text-base font-semibold leading-5 font-manrope">
                    {item?.description}
                </h3>
            </div>
        );
    });

    return (
        <>
            <div className="container px-4 mx-auto xl:mt-10 mt-5 text-center md:px-24 lg:px-24 xl:px-0">
                <div className="grid gap-10 py-6 lg:grid-cols-4 md:grid-cols-2 md:gap-20 place-content-center ">
                    {counterList}
                </div>
            </div>
        </>
    );
};

export default QuickCounterFacts;
